// extracted by mini-css-extract-plugin
export default {"concealed-triplet-table":"CountPointsPage_concealed-triplet-table__8Bq7Z"};